/**
 * Normod PLP Card – Color swatch interaction, image swap & hover image
 * Event delegation for performance; one listener handles all cards.
 */
(function () {
  'use strict';

  var TRANSPARENT_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function parseWidths(widthsJson) {
    try { return JSON.parse(widthsJson || '[]'); }
    catch (_) { return [200, 300, 400, 500, 600, 700, 800]; }
  }

  function buildSrcset(urlTemplate, widths) {
    var parts = [];
    for (var i = 0; i < widths.length; i++) {
      parts.push(urlTemplate.replace('__WIDTH__', widths[i]) + ' ' + widths[i] + 'w');
    }
    return parts.join(', ');
  }

  function bestWidthFor(el, widths) {
    var containerWidth = el.parentElement ? el.parentElement.offsetWidth : 400;
    var dpr = window.devicePixelRatio || 1;
    var target = Math.ceil(containerWidth * dpr);
    var best = widths[widths.length - 1] || 800;
    for (var i = 0; i < widths.length; i++) {
      if (widths[i] >= target) { best = widths[i]; break; }
    }
    return best;
  }

  function getOrCreateHoverImg(card) {
    var hoverImg = card.querySelector('.npc-card__image--hover');
    if (hoverImg) return hoverImg;

    var container = card.querySelector('.npc-card__image-container');
    if (!container) return null;

    hoverImg = document.createElement('img');
    hoverImg.className = 'npc-card__image npc-card__image--hover';
    hoverImg.setAttribute('loading', 'lazy');
    hoverImg.setAttribute('sizes', '(max-width: 767px) 50vw, 25vw');
    hoverImg.alt = '';
    hoverImg.src = TRANSPARENT_GIF;
    container.appendChild(hoverImg);
    return hoverImg;
  }

  function preloadAndSet(img, urlTemplate, widthsJson, addLoadingClass) {
    var widths = parseWidths(widthsJson);
    var best = bestWidthFor(img, widths);
    var srcset = buildSrcset(urlTemplate, widths);
    var newSrc = urlTemplate.replace('__WIDTH__', best);

    if (addLoadingClass) img.classList.add('npc-card__image--loading');

    var preload = new Image();
    var apply = function () {
      img.setAttribute('srcset', srcset);
      img.src = newSrc;
      if (addLoadingClass) img.classList.remove('npc-card__image--loading');
    };
    preload.onload = apply;
    preload.onerror = apply;
    preload.src = newSrc;
  }

  function handleSwatchClick(e) {
    var swatch = e.target.closest('[data-npc-swatch]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.npc-card');
    if (!card) return;

    var swatchGroup = card.querySelectorAll('[data-npc-swatch]');
    for (var i = 0; i < swatchGroup.length; i++) {
      swatchGroup[i].classList.remove('npc-card__swatch--active');
    }
    swatch.classList.add('npc-card__swatch--active');

    var newImageUrl = swatch.getAttribute('data-npc-image-url');
    var newImageWidths = swatch.getAttribute('data-npc-image-widths');
    var primaryImg = card.querySelector('.npc-card__image--primary');

    if (newImageUrl && primaryImg) {
      preloadAndSet(primaryImg, newImageUrl, newImageWidths, true);
    }

    var hoverUrl = swatch.getAttribute('data-npc-hover-url');
    var hoverWidths = swatch.getAttribute('data-npc-hover-widths');
    var hoverImg = getOrCreateHoverImg(card);

    if (hoverImg) {
      if (hoverUrl) {
        preloadAndSet(hoverImg, hoverUrl, hoverWidths, false);
      } else {
        hoverImg.removeAttribute('srcset');
        hoverImg.src = TRANSPARENT_GIF;
      }
    }

    var variantUrl = swatch.getAttribute('data-npc-variant-url');
    if (variantUrl) {
      var links = card.querySelectorAll('a[data-npc-product-link]');
      for (var k = 0; k < links.length; k++) {
        links[k].href = variantUrl;
      }
    }
  }

  document.addEventListener('click', handleSwatchClick);
})();
